/* eslint-disable import/prefer-default-export */
import BaseFeature from '@appblocks/codegeneration/BaseFeature';
import ProjectConfiguration from '@appblocks/codegeneration/ProjectConfiguration';
import {
    CodeBlock,
    BlockType,
    SettingType,
    Define,
    ValidationMessageType,
    ValidationMessage,
    SettingState,
    Setting,
    TibboDataType,
} from '@appblocks/codegeneration/types';
import BaseNode from '@appblocks/codegeneration/Nodes/BaseNode';
import NodePort from '@appblocks/codegeneration/Nodes/NodePort';
import NodeParameter from '@appblocks/codegeneration/Nodes/NodeParameter';

export const getCodeBlocks = (feature: BaseFeature): CodeBlock[] => {
    const blocks: Array<CodeBlock> = [];
    if (feature.getSettingValue('ENABLED').toString() === '0') {
        return blocks;
    }
    const MINY = feature.getSettingValue('MINY');
    const MAXY = feature.getSettingValue('MAXY');
    const STARTX = feature.getSettingValue('STARTX');
    const STARTY = feature.getSettingValue('STARTY');
    const WIDTH = feature.getSettingValue('WIDTH');
    const HEIGHT = feature.getSettingValue('HEIGHT');
    const FILL = feature.getSettingValue('FILL');
    const featureId = feature.getID();


    blocks.push({
        location: 'boot',
        blockType: BlockType.CODE,
        template: `
simulator.updateContext("${featureId}", {
    MINY: ${MINY},
    MAXY: ${MAXY},
    STARTX: ${STARTX},
    STARTY: ${STARTY},
    WIDTH: ${WIDTH},
    HEIGHT: ${HEIGHT},
    FILL: '${FILL}',
    DATAPOINTS: [],
    SCREEN_INDEX: 0,
});`,
    });

    return blocks;
};
